// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {CameraLayoutType, CameraViewMode, CameraLayoutMap} from "@models";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {animate, style, transition, trigger} from "@angular/animations";
import {SimUtilityService} from "@services";

@Component({
	selector: "sim-camera-view-mode-selector",
	templateUrl: "./camera-view-mode-selector.component.html",
	styleUrls: ["./camera-view-mode-selector.component.scss"],
	animations: [
		zoomInOnEnterAnimation({duration: 250}),
		zoomOutOnLeaveAnimation({duration: 250}),
		trigger("testAnim", [
			transition(":enter", [style({width: 0, opacity: 0}), animate("200ms ease-out", style({width: 500, opacity: 1}))]),
			transition(":leave", [style({width: 500, opacity: 1}), animate("200ms ease-in", style({width: 0, opacity: 0}))]),
		]),
	],
	standalone: false,
})
export class CameraViewModeSelectorComponent implements OnInit {
	readonly CameraLayoutMap = CameraLayoutMap;
	CameraViewMode = CameraViewMode;
	CameraLayoutType = CameraLayoutType;
	unsorted = SimUtilityService.unsorted;

	@Input() currentCameraLayout: CameraLayoutType;
	@Input() currentCameraViewMode: CameraViewMode;
	cameraViewModeChanged = output<CameraViewMode>();

	constructor() {}

	public ngOnInit() {}

	public selectCameraViewMode(cameraViewMode: CameraViewMode) {
		this.currentCameraViewMode = cameraViewMode;

		this.cameraViewModeChanged.emit(cameraViewMode);
	}
}
